import { ITEM_STATUS } from 'utils/status';
import ITEM_KEYS, { CONFIG_ITEM_KEYS } from './keys';
import { PRICING_STRATEGIES } from '../../resources/constants';

export const TRANSLATION = () => ({
  title: '',
  description: ''
});

export const CONFIG = () => ({
  [CONFIG_ITEM_KEYS.DESCRIPTION_REQUIRED]: true,
  [CONFIG_ITEM_KEYS.MKT_PRICE]: false,
})

export const CATEGORY = (id) => ({category: id, subcategories: []});

export const VARIANT = {
  [ITEM_KEYS.TRANSLATIONS]: {
    en: '',
    es: '',
  },
  [ITEM_KEYS.PRICE]: '0',
  [ITEM_KEYS.ACTIVE]: true,
  [ITEM_KEYS.POS_CODE]: '',
  [ITEM_KEYS.PRICING_STRATEGY]: PRICING_STRATEGIES.basePrice,
  [ITEM_KEYS.CONFIG]: null,
}

const INIT_STATE = () => ({
  [ITEM_KEYS.CATEGORIES]: [],
  [ITEM_KEYS.FAMILY]: [],
  [ITEM_KEYS.IMAGE]: '',
  [ITEM_KEYS.INGREDIENTS]: [],
  [ITEM_KEYS.LOGO]: '',
  [ITEM_KEYS.STATUS]: ITEM_STATUS.ACTIVE,
  [ITEM_KEYS.STOCK_ALERT]: 0,
  [ITEM_KEYS.STOCK_PAR]: 0,
  [ITEM_KEYS.STOCK_TOTAL]: 1,
  [ITEM_KEYS.TAGS]: [],
  [ITEM_KEYS.TRANSLATIONS]: {
    en: {...TRANSLATION()},
    es: {...TRANSLATION()},
  },
  [ITEM_KEYS.CONFIG]: {
    ...CONFIG()
  },
  [ITEM_KEYS.VARIANTS]: [
    {...VARIANT}
  ],
  [ITEM_KEYS.HAS_CHANGED]: false,
});

export default INIT_STATE;
